import { handleActions } from 'redux-actions'

import {
  hasError,
  isLoading,
  provincias,
  limites,
  tiposConstruccion,
  coberturas,
  maxCoberturas,
  girosNegocio,
  coberturasGenerales,
  coberturasGeneralesEE,
  coberturasGeneralesVC,
  idGiro
} from '../actions/aRamoPymes';




export default handleActions(
  {
    [isLoading]: (state) => { return { ...state, isLoading: true, hasError: '' }; },
    [hasError]: (state, action) => ({ ...state, hasError: action.payload, isLoading: false, date: '' }),
    [provincias]: (state, action) => ({ ...state, isLoading: false, provincias: action.payload, date: new Date() }),
    [limites]: (state, action) => ({ ...state, isLoading: false, limites: action.payload, date: new Date() }),
    [tiposConstruccion]: (state, action) => ({ ...state, isLoading: false, tiposConstruccion: action.payload, date: new Date() }),
    [coberturas]: (state, action) => ({ ...state, isLoading: false, coberturas: action.payload, date: new Date() }),
    [maxCoberturas]: (state, { payload }) => ({ ...state, maxCoberturas: { ...state.maxCoberturas, ...payload } }),
    [girosNegocio]: (state, action) => ({ ...state, isLoading: false, girosNegocio: action.payload }),
    [coberturasGenerales]: (state, { payload }) => ({ ...state, isLoading: false, coberturasGenerales: { ...state.coberturasGenerales, ...payload } }),
    [coberturasGeneralesEE]: (state, action) => ({ ...state, isLoading: false, coberturasGeneralesEE: action.payload }),
    [coberturasGeneralesVC]: (state, action) => ({ ...state, isLoading: false, coberturasGeneralesVC: action.payload }),
    [idGiro]: (state, action) => ({ ...state, isLoading: false, idGiro: action.payload }),
  },
  {
    isLoading: false, hasError: '', provincias: [], limites: [], tiposConstruccion: [], date: '', maxCoberturas: {}, girosNegocio: [], coberturasGenerales: []
  }
);

//; state.maxCoberturas.concat(action.payload)